@if (isLoaded) {
  <aecom-form columns="12" class="contentcontainer">
    <aecom-form-group columnSpan="12" columns="2" title="General">
      <aecom-form-item [label]="'From (Sender)'" columnSpan="1">
        <div class="itemText">
          {{ orignator }}
        </div>
      </aecom-form-item>
      <aecom-form-item [label]="'Letter Date'" columnSpan="1">
        <div class="itemText">
          {{ letterDate }}
        </div>
      </aecom-form-item>
      <aecom-form-item [label]="'To (Recipient)'" columnSpan="1">
        <div class="itemText">
          {{ recipent }}
        </div>
      </aecom-form-item>
      <aecom-form-item [label]="'Organization Reference Number'" columnSpan="1">
        <div class="itemText">
          {{ organizationReferenceNumber }}
        </div>
      </aecom-form-item>
      <aecom-form-item [label]="'Reference'" columnSpan="2">
        <div class="itemText">
          {{ reference }}
        </div>
      </aecom-form-item>
      <aecom-form-item [label]="'Subject'" columnSpan="2">
        <div class="itemText">
          {{ subject }}
        </div>
      </aecom-form-item>
      <aecom-form-item [label]="'Additional Notes'" columnSpan="2">
        <div class="itemText">
          {{ note }}
        </div>
      </aecom-form-item>
      <aecom-form-item columnSpan="1">
        <bbj-file-list
          title="Correspondence File"
          [fileList]="correspondenceFile"
          [allowMovingFiles]="false"
        ></bbj-file-list>
      </aecom-form-item>
      <aecom-form-item columnSpan="1">
        <bbj-file-list
          title="Attachments"
          [fileList]="attachments"
          [allowMovingFiles]="false"
        ></bbj-file-list>
      </aecom-form-item>
    </aecom-form-group>
  </aecom-form>
}

<ng-template #notAvailable>
  <div class="itemText">N/A</div>
</ng-template>
